import Shipping from '../components/shipping';

const CheckProdCD = {
  init: function() {
    console.log('Check Prod CD called');

    Shipping.init();
  }
}

export default CheckProdCD;